var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "company" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司名称" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "company", $$v)
                          },
                          expression: "searchForm.company",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "orderid" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入订单号" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.orderid,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderid", $$v)
                          },
                          expression: "searchForm.orderid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "picker-options": _vm.pickerOptions,
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: { change: _vm.handleDateChange },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.sendtime,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "sendtime", $$v)
                          },
                          expression: "searchForm.sendtime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "zt" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "审核状态", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.zt,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "zt", $$v)
                            },
                            expression: "searchForm.zt",
                          },
                        },
                        _vm._l(_vm.examineStatus, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(_vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "kpzt" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "开票状态", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.kpzt,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "kpzt", $$v)
                            },
                            expression: "searchForm.kpzt",
                          },
                        },
                        _vm._l(_vm.invoicingStatus, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(_vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "fkzt" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "付款状态", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.fkzt,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "fkzt", $$v)
                            },
                            expression: "searchForm.fkzt",
                          },
                        },
                        _vm._l(_vm.paymentStatus, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(_vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSearchBtn()
                        },
                      },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.handleResetBtn("searchForm")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table search-table" },
        [
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item el-icon-download",
              attrs: {
                loading: _vm.exportLoading,
                type: "success",
                size: "small",
              },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出Excel ")]
          ),
          _c("BatchExamineContract", {
            attrs: {
              showBatchContract: _vm.showBatchContract,
              selectedIds: _vm.selectId,
            },
            on: {
              submit: _vm.handleExamineSubmit,
              "update:showBatchContract": function (val) {
                return (_vm.showBatchContract = val)
              },
            },
          }),
          _c("BatchExamineKp", {
            attrs: { showBatchKp: _vm.showBatchKp, selectedIds: _vm.selectId },
            on: {
              submit: _vm.handleExamineSubmit,
              "update:showBatchKp": function (val) {
                return (_vm.showBatchKp = val)
              },
            },
          }),
          _c("BatchExaminePay", {
            attrs: { selectedIds: _vm.selectId },
            on: { submit: _vm.handleExamineSubmit },
          }),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("Expand", { attrs: { data: scope.row.childdata } }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { label: "ID", prop: "id" } }),
              _c("el-table-column", {
                attrs: { label: "订单号", prop: "orderid", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleShowOrder(row.childdata)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.orderid))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "所属公司", prop: "company", width: "240" },
              }),
              _c("el-table-column", {
                attrs: { label: "负责人", prop: "rname" },
              }),
              _c("el-table-column", {
                attrs: { label: "合同状态", prop: "zt" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          staticClass: "status_btn",
                          style:
                            scope.row.zt == "已审"
                              ? "color:green"
                              : "color: red",
                          attrs: {
                            icon:
                              scope.row.zt == "已审"
                                ? "el-icon-success"
                                : "el-icon-error",
                            type: "text",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "开票状态", prop: "kpzt" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.kpzt == "未"
                          ? _c("span", [_vm._v(_vm._s(scope.row.kpzt))])
                          : _c("el-button", {
                              staticClass: "status_btn",
                              style:
                                scope.row.kpzt == "已开"
                                  ? "color:green"
                                  : "color: red",
                              attrs: {
                                icon:
                                  scope.row.kpzt == "已开"
                                    ? "el-icon-success"
                                    : "el-icon-error",
                                type: "text",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "付款状态", prop: "fkzt" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.fkzt === "已付" || scope.row.fkzt === "未付"
                          ? _c("el-button", {
                              staticClass: "status_btn",
                              style:
                                scope.row.fkzt == "已付"
                                  ? "color:green"
                                  : "color: red",
                              attrs: {
                                icon:
                                  scope.row.fkzt == "已付"
                                    ? "el-icon-success"
                                    : "el-icon-error",
                                type: "text",
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row.fkzt))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "联系人", prop: "lxr", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "price", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "签定时间", prop: "sendtime", width: "120" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "470",
                  fixed: _vm.getIsMobile ? false : "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleExamine(
                                  { type: "single" },
                                  scope.row
                                )
                              },
                            },
                          },
                          [_vm._v(" 审核 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: {
                              type: "primary",
                              size: "small",
                              disabled: scope.row.ow_type === "F",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope)
                              },
                            },
                          },
                          [_vm._v(" 编辑 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleOutboundOrder(scope)
                              },
                            },
                          },
                          [_vm._v(" 出库单 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-edit-outline",
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlePrintContract(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 打印合同 ")]
                        ),
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              iconColor: "red",
                              title: "确认删除此条数据吗？",
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.handleDelete(scope, scope.$index)
                              },
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "el-icon-delete",
                                attrs: {
                                  slot: "reference",
                                  size: "small",
                                  type: "danger",
                                  disabled: scope.row.ow_type === "F",
                                },
                                slot: "reference",
                              },
                              [_vm._v("删除")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("Edit", {
        attrs: {
          dialog: _vm.dialog,
          "form-data": _vm.editFormData,
          type: _vm.type,
          submitLoading: _vm.submitLoading,
        },
        on: { submit: _vm.handleSubmit, close: _vm.handleClose },
      }),
      _c("Examine", {
        attrs: {
          examineDialog: _vm.examineDialog,
          "form-data": _vm.editFormData,
          data: _vm.examine,
          examineContract: _vm.examineContract,
        },
        on: { close: _vm.handleClose, submit: _vm.handleExamineSubmit },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "contract-dialog",
          attrs: {
            visible: _vm.showContract,
            title: "修改合同",
            width: _vm.getIsMobile ? "100%" : "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showContract = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("Contract", { ref: "contractRef", attrs: { data: _vm.editData } }),
          _c("el-tag", { staticClass: "contract-tag" }, [
            _c(
              "span",
              { staticClass: "contract-link", attrs: { type: "primary" } },
              [_vm._v("总价：" + _vm._s(_vm.totalAmount))]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleEditSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "contract-dialog",
          attrs: {
            visible: _vm.showOutboundOrder,
            title: "出库单",
            width: _vm.getIsMobile ? "100%" : "60%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showOutboundOrder = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c("OutboundOrder", {
            attrs: { data: _vm.outboundOrder, id: _vm.contactId },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关 闭"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "订单",
            size: "50%",
            visible: _vm.drawer,
            direction: "rtl",
            "before-close": _vm.handleCloseDrawer,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [_c("Order", { attrs: { data: _vm.orderData } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }